/* eslint-disable import/no-named-as-default */
import React, { Component, Fragment, ReactNode } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Bar from "../../Charts/Bar";
import AnalyticsWidgetLoading from "../../shared/loaders/AnalyticsWidgetLoading";
import { Wrapper } from "../styles/charts-styles";
import { ChartTitle } from "../styles/employer-analytics-styles";
import ReactTooltip from "react-tooltip";

export interface IPlacementsMadeProps {
  placementMade: {
    months?: Date[];
    values?: number[];
  };
  placementsMadeWidgetLoader: boolean;
}

interface IPlacementsMadeState {
  placementsMadeWidgetLoader: boolean;
}

export class PlacementsMade extends Component<
  IPlacementsMadeProps,
  IPlacementsMadeState
> {
  static propTypes = {
    placementMade: PropTypes.shape({
      months: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
      values: PropTypes.arrayOf(PropTypes.number),
    }),
    placementsMadeWidgetLoader: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    placementMade: {
      months: [],
      values: [],
    },
  };

  render(): ReactNode {
    const { placementMade, placementsMadeWidgetLoader } = this.props;
    const placementsMadeOptions = {
      series: [
        {
          name: "Placement Made",
          data: placementMade.values,
        },
      ],
      options: {
        colors: ["#673490"],
        height: 350,
        width: 400,
        chart: {
          toolbar: {
            show: false,
          },
          position: "top",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
          formatter: (val: number) => val,
          offsetX: 0,
          offsetY: 0,
          style: {
            fontSize: "11px",
            colors: ["#333"],
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 4,
            borderRadiusApplication: "end",
            dataLabels: {
              position: "bottom",
            },
          },
        },
        xaxis: {
          type: "datetime",
          categories: placementMade.months.map((date) => date.getTime()),
          title: {
            text: "Time",
          },
        },
        yaxis: {
          title: {
            text: "Number of Placements",
          },
          min: 0,
          max: Math.max(...placementMade.values, 10),
        },
        tooltip: {
          x: {
            formatter: function (value) {
              const date = new Date(value);
              return date.toLocaleString("default", { month: "short" });
            },
          },
        },
      },
    };

    return (
      <Fragment>
        <Wrapper
          className="animated fadeIn delay-5"
          id="placements-made-widget"
        >
          <AnalyticsWidgetLoading
            text="Updating..."
            active={placementsMadeWidgetLoader}
          />

          <Bar
            graphOptions={placementsMadeOptions}
            dataTestId="placements-made-chart"
          />
          <ChartTitle
            marginBottom={20}
            data-test-id="placements-made-title"
            data-tip="Number of roles successfully filled."
            data-for="placements-made-title-tooltip"
          >
            <ReactTooltip
              type="dark"
              aria-haspopup="true"
              id="placements-made-title-tooltip"
              className="tooltip-max-width"
            />
            Placements
          </ChartTitle>
        </Wrapper>
      </Fragment>
    );
  }
}

interface IReduxState {
  employerAnalytics: {
    jobPerformanceData: {
      placementMade: {
        months: Date[];
        values: number[];
      };
    };
    placementsMadeWidgetLoader: boolean;
  };
}

const mapStateToProps = (state: IReduxState) => ({
  placementMade: state.employerAnalytics.jobPerformanceData.placementMade,
  placementsMadeWidgetLoader:
    state.employerAnalytics.placementsMadeWidgetLoader,
});
export default connect(mapStateToProps, {})(PlacementsMade);
